// extracted by mini-css-extract-plugin
export default {"assignedCell":"employee-allocation-table_assignedCell__3avny"};